import { useState, useEffect, useContext } from 'react';
import AuthContext from '../../AuthContext';
import axios from '../../axios';

const SectorDropdown = ({ value, handleInputChange, dont, imp, tc, reports }) => {
  const { centre, userType } = useContext(AuthContext);
  const [sectors, setSectors] = useState([]);
  const [err, setErr] = useState(false);
  const centreId = reports ? tc : centre;

  useEffect(() => {
    const fetchSectors = async () => {
      try {
        const response = await axios.post('/sector/getall', {
          centre_id: centreId,
        });
        setSectors(response.data);
      } catch (error) {
        setErr(true);
      }
    };

    fetchSectors();
  }, [centreId]);

  return (
    <div className="flex flex-col">
      <label htmlFor="sector" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        Sector Name &nbsp;
        {imp && <span className="text-red-600">*</span>}
      </label>

      <select
        value={value}
        disabled={dont}
        onChange={handleInputChange}
        className={`bg-gray-50 border ${err ? 'border-red-600' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
      >
        <option value="" disabled>Select Sector</option>
        {sectors.map((sector) => (
          <option key={sector.sector_id} value={sector.sector_id}>
            {sector.sector_name} {((userType === 'Superadmin' || userType === 'Manager') && !reports) && `,[${sector.centre_name}]`}
          </option>
        ))}
      </select>

      {err && <p className="text-red-600 mt-2">Failed to fetch sectors. Please try again.</p>}
    </div>
  );
};

export default SectorDropdown;
